module.exports = __webpack_public_path__ + "img/fee.3eb12f96.svg";